/* KAIRÓS – interactions. Plain JS, no dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* Mobile menu */
  function initMenu() {
    var drawer = document.querySelector('[data-kx-drawer]');
    if (!drawer) return;
    document.querySelectorAll('[data-kx-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    });
    drawer.querySelectorAll('[data-kx-menu-close], a').forEach(function (b) {
      b.addEventListener('click', function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.kx-reveal');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Horizontal rails: arrows, progress bar, drag with mouse */
  function initRails() {
    document.querySelectorAll('[data-kx-rail]').forEach(function (root) {
      var rail = root.querySelector('.kx-rail');
      if (!rail) return;
      var bar = root.querySelector('.kx-progress i');
      function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : rail.clientWidth * .8; }
      root.querySelectorAll('[data-kx-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      root.querySelectorAll('[data-kx-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); }); });
      function upd() {
        if (!bar) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var vis = rail.clientWidth / rail.scrollWidth;
        bar.style.width = Math.max(vis * 100, 8) + '%';
        var p = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1 / Math.max(vis, .08) - 1) * 100) + '%)';
      }
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      var down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = rail.scrollLeft; rail.classList.add('is-drag'); });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; rail.classList.remove('is-drag'); });
      rail.addEventListener('mousemove', function (e) { if (!down) return; var d = e.pageX - sx; if (Math.abs(d) > 4) moved = true; rail.scrollLeft = sl - d; });
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* Pinned horizontal chapters: vertical scroll moves the track sideways (desktop) */
  function initChapters() {
    var list = document.querySelectorAll('[data-kx-chapters]');
    if (!list.length) return;
    function layout() {
      list.forEach(function (root) {
        var pin = root.querySelector('.kx-ch__pin');
        var track = root.querySelector('.kx-ch__track');
        if (!pin || !track) return;
        var desktop = window.innerWidth >= 900 && !reduce;
        root.classList.toggle('is-pinned', desktop);
        if (!desktop) { pin.style.height = ''; track.style.transform = ''; return; }
        var dist = track.scrollWidth - window.innerWidth;
        pin.style.height = (window.innerHeight + Math.max(dist, 0)) + 'px';
        root._kxDist = dist;
      });
      tick();
    }
    function tick() {
      list.forEach(function (root) {
        if (!root.classList.contains('is-pinned')) return;
        var pin = root.querySelector('.kx-ch__pin');
        var track = root.querySelector('.kx-ch__track');
        var r = pin.getBoundingClientRect();
        var total = pin.offsetHeight - window.innerHeight;
        var p = total > 0 ? Math.min(Math.max(-r.top / total, 0), 1) : 0;
        track.style.transform = 'translate3d(' + (-p * (root._kxDist || 0)) + 'px,0,0)';
        var bar = root.querySelector('.kx-ch__bar i');
        if (bar) bar.style.transform = 'scaleX(' + p + ')';
      });
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    layout();
  }

  /* Live watch hands */
  function initClock() {
    var watches = document.querySelectorAll('[data-kx-live]');
    if (!watches.length) return;
    function set() {
      var d = new Date();
      var s = d.getSeconds(), m = d.getMinutes() + s / 60, h = (d.getHours() % 12) + m / 60;
      watches.forEach(function (w) {
        var hh = w.querySelector('[data-kx-hand="h"]'), mm = w.querySelector('[data-kx-hand="m"]'), ss = w.querySelector('[data-kx-hand="s"]');
        if (hh) hh.style.transform = 'rotate(' + (h * 30) + 'deg)';
        if (mm) mm.style.transform = 'rotate(' + (m * 6) + 'deg)';
        if (ss) ss.style.transform = 'rotate(' + (s * 6) + 'deg)';
      });
      document.querySelectorAll('[data-kx-time]').forEach(function (el) {
        el.textContent = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
      });
    }
    set();
    setInterval(set, 1000);
  }

  /* Product page: option buttons -> variant, gallery dots */
  function initProduct() {
    document.querySelectorAll('[data-kx-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-kx-variants]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var input = root.querySelector('input[name="id"]');
      var price = root.querySelector('[data-kx-price]');
      var compare = root.querySelector('[data-kx-compare]');
      var btn = root.querySelector('[data-kx-add]');
      var btnText = btn ? btn.querySelector('span') : null;
      var groups = root.querySelectorAll('[data-kx-option]');
      function selected() { return Array.prototype.map.call(groups, function (g) { var a = g.querySelector('.is-active'); return a ? a.getAttribute('data-value') : null; }); }
      function update() {
        var sel = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) return;
        if (input) input.value = v.id;
        if (price) price.textContent = v.price;
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
        if (btn) { btn.disabled = !v.available; if (btnText) btnText.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout'); }
        root.querySelectorAll('[data-kx-media-id]').forEach(function (m) {
          if (v.media && String(m.getAttribute('data-kx-media-id')) === String(v.media)) {
            var track = m.parentElement; track.scrollTo({ left: m.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        });
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      groups.forEach(function (g) {
        g.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
            b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
            var lbl = g.querySelector('[data-kx-option-value]'); if (lbl) lbl.textContent = b.getAttribute('data-value');
            update();
          });
        });
      });
      var track = root.querySelector('.kx-pg__track');
      var dots = root.querySelectorAll('.kx-pg__dots button');
      if (track && dots.length) {
        dots.forEach(function (d, i) { d.addEventListener('click', function () { var s = track.children[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        }, { passive: true });
      }
    });
  }

  ready(function () { initMenu(); initReveal(); initRails(); initChapters(); initClock(); initProduct(); });
})();
